import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ApiError, resolveShareLink } from "../lib/api.js";
import { setShareSession } from "../lib/shareSession.js";

export function ShareLandingPage() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    if (!token) return;
    void (async () => {
      try {
        const share = await resolveShareLink(token);
        setShareSession(share.kind, share.id, token);
        const segment = share.kind === "list" ? "lists" : share.kind === "template" ? "templates" : "checklists";
        navigate(`/${segment}/${share.id}`, { replace: true });
      } catch (err) {
        if (err instanceof ApiError && err.code === "SHARE_REQUIRES_SIGNIN") {
          navigate(`/login?next=${encodeURIComponent(`/s/${token}`)}`, { replace: true });
          return;
        }
        setMessage("This link is no longer active.");
      }
    })();
  }, [navigate, token]);

  if (!message) return <div className="flex min-h-full items-center justify-center text-sm text-muted">Opening shared resource...</div>;
  return <main className="mx-auto flex min-h-full max-w-md flex-col justify-center px-6 py-12 text-center">
    <h1 className="text-2xl font-semibold text-ink">{message}</h1>
    <p className="mt-3 text-sm text-muted">Ask the owner for a new link, or request access if you know the resource URL.</p>
    <Link to="/" className="mt-6 text-sm font-medium text-brand-700">Go to NeatTick</Link>
  </main>;
}
